import React, { useRef, useState } from "react";
import Swal from "sweetalert2";
import { useAdminTheme } from "./StageTabs";
import { assetUrl } from "../../functions/themeAssets";
import { uploadChallengeImage } from "../functions/stageApi";

const MAX_MB = 5;

/** Upload (or reset) the banner shown at the top of a challenge. PNG only, any size. */
export default function ChallengeImage({ stage }) {
  const { adminToken, currentTheme, data, reload } = useAdminTheme();
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const current = data && data[`challenge_image_${stage}`];
  const preview = current ? assetUrl(current) : `${process.env.PUBLIC_URL || ""}/img/bp/layer${stage}.png`;

  const pick = (f, input) => {
    if (!f) return setFile(null);
    if (!/\.png$/i.test(f.name) || f.type !== "image/png") {
      input.value = "";
      setFile(null);
      return Swal.fire("Only PNG images are allowed.", "", "error");
    }
    if (f.size > MAX_MB * 1024 * 1024) {
      input.value = "";
      setFile(null);
      return Swal.fire(`Filesize exceeds max limit ${MAX_MB} MB`, "", "error");
    }
    setFile(f);
  };

  const send = async (form, okTitle) => {
    setBusy(true);
    try {
      await uploadChallengeImage({ token: adminToken, formData: form });
      await reload();
      setFile(null);
      if (inputRef.current) inputRef.current.value = "";
      Swal.fire({ title: okTitle, icon: "success", timer: 1200, showConfirmButton: false });
    } catch (e) {
      Swal.fire(e.message, "", "error");
    } finally {
      setBusy(false);
    }
  };

  const onUpload = (e) => {
    e.preventDefault();
    if (!file) return Swal.fire("Please choose a PNG image", "", "error");
    const fd = new FormData();
    fd.append("themeName", currentTheme);
    fd.append("stage", stage);
    fd.append("file", file);
    send(fd, "Successfully Updated");
  };

  const onReset = () => {
    const fd = new FormData();
    fd.append("themeName", currentTheme);
    fd.append("stage", stage);
    fd.append("reset", "true");
    send(fd, "Default image restored");
  };

  return (
    <div className="bp-card">
      <h4>Challenge {stage} Image</h4>
      <div className="bp-row">
        <div className="bp-col">
          <form onSubmit={onUpload}>
            <input
              type="file"
              ref={inputRef}
              className="bp-input"
              accept=".png,image/png"
              onChange={(e) => pick(e.target.files[0], e.target)}
            />
            <p className="bp-note">* PNG only, any size &nbsp; * It is fitted and centred at the top of Challenge {stage}</p>
            <div className="bp-actions">
              <button type="submit" className="bp-btn" disabled={busy}>
                <i className="fa-solid fa-cloud-arrow-up" /> Upload
              </button>
              {current && (
                <button type="button" className="bp-btn secondary" onClick={onReset} disabled={busy}>
                  Use default
                </button>
              )}
            </div>
          </form>
        </div>
        <div className="bp-col" style={{ textAlign: "center" }}>
          <img src={preview} alt={`Challenge ${stage}`} className="bp-preview" style={{ maxWidth: 260, maxHeight: 110, objectFit: "contain" }} />
        </div>
      </div>
    </div>
  );
}
